import { camelCase, snakeCase } from 'lodash'

export type Obj = unknown[] | Record<string, unknown>

interface FormatMoneyOptions {
  locale?: string
  currency?: string
  maximumFractionDigits?: number
  minimumFractionDigits?: number
  isCents?: boolean
}

export const parseObject: (val: Obj, fn: (val: string) => string) => Obj = (val, fn) => {
  if (Array.isArray(val)) {
    return val.map((v) => (v && typeof v === 'object' ? parseObject(v as Obj, fn) : v))
  }

  if (typeof val !== 'object' || val === null || val === undefined) {
    return val
  }

  const newObj: Obj = {}

  for (const d in val) {
    if (Object.prototype.hasOwnProperty.call(val, d)) {
      newObj[fn(d)] = val[d] && typeof val[d] === 'object' ? parseObject(val[d] as Obj, fn) : val[d]
    }
  }

  return newObj
}

export const snakeToCamel = (obj: Obj) => parseObject(obj, camelCase)
export const camelToSnake = (obj: Obj) => parseObject(obj, snakeCase)

export const formatMoney: (num: number, formatMoneyOptions?: FormatMoneyOptions) => string = (
  num,
  options = {
    locale: 'en-US',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    isCents: true,
  },
) => {
  const isNonZeroFalsy = !num && num !== 0
  if (isNonZeroFalsy || isNaN(num)) return ''

  const { isCents } = options

  const amount = isCents ? num / 100 : num

  return Intl.NumberFormat('USD').format(amount)
}
